import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class CiudadesService extends ApiService {
  entityType = EntityType.CIUDAD;
  url = 'api/ciudades/';
}
